export default __webpack_public_path__ + "static/media/SAS-QI.8442dc81.png";